__turbopack_context__.v({
  "attackItem": "ThreatDetailPage-module-scss-module__Xkuhla__attackItem",
  "description": "ThreatDetailPage-module-scss-module__Xkuhla__description",
  "detailSection": "ThreatDetailPage-module-scss-module__Xkuhla__detailSection",
  "detailTable": "ThreatDetailPage-module-scss-module__Xkuhla__detailTable",
  "detailTableWrapper": "ThreatDetailPage-module-scss-module__Xkuhla__detailTableWrapper",
  "lastUpdated": "ThreatDetailPage-module-scss-module__Xkuhla__lastUpdated",
  "mitreMatrixCard": "ThreatDetailPage-module-scss-module__Xkuhla__mitreMatrixCard",
  "mitreMatrixSection": "ThreatDetailPage-module-scss-module__Xkuhla__mitreMatrixSection",
  "mitreMatrixVersion": "ThreatDetailPage-module-scss-module__Xkuhla__mitreMatrixVersion",
  "mitreMatrixVersionLabel": "ThreatDetailPage-module-scss-module__Xkuhla__mitreMatrixVersionLabel",
  "rowData": "ThreatDetailPage-module-scss-module__Xkuhla__rowData",
  "rowLabel": "ThreatDetailPage-module-scss-module__Xkuhla__rowLabel",
  "tactic": "ThreatDetailPage-module-scss-module__Xkuhla__tactic",
  "tag": "ThreatDetailPage-module-scss-module__Xkuhla__tag",
  "tagsContainer": "ThreatDetailPage-module-scss-module__Xkuhla__tagsContainer",
  "threatHeader": "ThreatDetailPage-module-scss-module__Xkuhla__threatHeader",
});
